'use strict';

var AppDialogsActions = function AppDialogsActions (Flux, APP_DISPATCHER_ID) {

  var Actions = Flux.Actions.create('AppDialogsActions', APP_DISPATCHER_ID);

  Actions.add({
    name: 'GetSelectPlanPage',
    purpose: 'Show to the user an emmersive plan selection page',
    payload: []
  });

  Actions.add({
    name: 'InsufficientSubscriptionPrivileges',
    purpose: 'To block the user from continuing with a process',
    payload: []
  });

  Actions.add({
    name: 'GetCheckoutPage',
    purpose: 'Attempt to fetch the subscription checkout hosted page from Chargebee',
    payload: ['plan_id', 'coupon_code']
  });

  Actions.add({
    name: 'GetSuccessfulSignup',
    purpose: 'To display a successful subscription signup to the user',
    payload: []
  });

  Actions.add({
    name: 'NotSupportedInPlan',
    purpose: 'The Plan governing this feature doesn\'t have access to this feature',
    payload: []
  });

  Actions.add({
    name: 'SavingNotSupportedInPlan',
    purpose: 'The Plan governing this feature doesn\'t have access to this feature',
    payload: []
  });

  Actions.add({
    name: 'DisabledForAdmins',
    purpose: 'Notify the user that this is disabled because they are in an Admin Session',
    payload: []
  });

  Actions.add({
    name: 'UnableToFetchSubscription',
    purpose: 'Notify user of a failure to fetch plan data',
    payload: []
  });

  Actions.add({
    name: 'MustBePayingCustomer',
    purpose: 'Notify user that this is a paying only feature',
    payload: []
  });

  Actions.add({
    name: 'PromptDeleteSite',
    purpose: 'Let confirm user if he really wants to delete a site',
    payload: ['site']
  });

  Actions.add({
    name: 'PromptMapboxglWelcome',
    purpose: 'Show MapboxGL beta feature subscription',
    payload: ['site']
  });

  return Actions;
};

AppDialogsActions.$inject = ['sbFlux', 'APP_DISPATCHER_ID'];
module.exports = AppDialogsActions;



// WEBPACK FOOTER //
// ./src/app/dialogs/AppDialogsActions.js